export default "__VITE_ASSET__2_yxPM2Y__"